import * as React from 'react';
import { LinkButton } from '@cian/ui-kit/button';

interface ICalculatorLinkProps {
  link: string;
  onClick?(): void;
}

export const CalculatorLink: React.FC<ICalculatorLinkProps> = props => {
  return (
    <LinkButton
      theme="fill_secondary"
      size="XS"
      href={props.link}
      rel="noreferrer nofollow noopener"
      target="_blank"
      onClick={props.onClick}
    >
      Смотреть полный отчет
    </LinkButton>
  );
};

CalculatorLink.displayName = 'CalculatorLink';
